{
  "messages": {
    "rescheduledOnce": "日時変更 1 回",
    "rescheduledTwice": "日時変更 2 回",
    "rescheduledCountTimes": "日時変更 {count} 回"
  }
}
